<template>
  <v-app>
    <toolbar-component />
    <v-content>
      <!-- <v-slide-y-transition mode="out-in"> -->
      <router-view />
      <!-- </v-slide-y-transition> -->
    </v-content>
    <footer-component />
    <dialog-loading />
    <dialog-warning-navigation />
    <snack />
  </v-app>
</template>
<script>
export default {
	computed: {
		carts() {
			return this.$store.state.carts
		}
	},
	watch: {
		carts() {
			if (this.carts.length == 0) this.$router.push('/')
		}
	},
	mounted() {
		this.$nextTick(() => {
			if (this.$cookie.get('varasto-otto-user')) {
				this.$store.state.selected_user = this.$cookie.get('varasto-otto-user')
				this.$store.state.usermenu = false
			}
			this.$store.commit('init')
		})
	}
}
</script>
<style>
* {
  transition: none !important;
}
html {
  overscroll-behavior: contain;
}
.application--wrap {
  background: url("/laudat4.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  min-height: 100vh;
}
.v-expansion-panel__header {
  padding: 0 16px !important;
}
.expansion {
  box-shadow: none !important;
}
</style>
